/*eslint-disable*/
import React, { useState, useMemo } from "react";
import deleteLight from "assets/images/secretManagement/deleteLight.svg";
import deleteDark from "assets/images/secretManagement/deleteDark.svg";
import editLight from "assets/images/secretManagement/editLight.svg";
import editDark from "assets/images/secretManagement/editDark.svg";
// import shareLight from "assets/images/secretManagement/shareLight.svg";
import copy from "assets/images/authenticate/copy.svg";
import copyDark from "assets/images/authenticate/copyDark.svg";
// import shareDark from "assets/images/secretManagement/shareDark.svg";
import deleteContentLight from "assets/images/secretManagement/deleteContentLight.svg";
import deleteContentDark from "assets/images/secretManagement/deleteContentDark.svg";
import noData from "assets/images/homepage/PasswordManger/noResult/Nodata.png";
import induzLogo from "assets/images/homepage/logoIcon.svg";
import induzLogoDark from "assets/images/homepage/logoIcondark.svg";

import { useTable } from "react-table";
import "./secretsTable.scss";
import SquareCheckBox from "components/SquareCheckBox/index";
import useTheme from "hooks/observer";
import DeleteModal from "components/DeleteModal/index";
import Input from "components/Input/index";
import Button from "components/Button/index";
import Modal from "components/Models/index";
import SecretShare from "components/SecretShare/SecretShare";
import AddSecret from "components/AddSecret/AddSecret";
import useScreenMobile from "hooks/useScreen";
import Drawer from "components/Drawer/index";
import EmptySecret from "components/EmptySecret/EmptySecret";
//import useref
import { useRef } from "react";
import { useToast } from "components/Toaster/index";

import { deleteSecret, callDeletePin } from "containers/SecretManagement/helper";
const SecretsTable = ({
  activeTab,
  handleCreateSecretModal,
  secretsList,
  setSecretsList,
  formData,
  setFormData,
  setFormErrors,
  formErrors,
  hasTabData,
  selectedTab,
  handleSaveAddSecret,
  searchQuery = "",
  setActiveCard
}) => {

  const showToast = useToast();
  const [selectedRows, setSelectedRows] = useState({});
  const [editingIndex, setEditingIndex] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDeleteModalRow, setOpenDeleteModalRow] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const isMobile = useScreenMobile({ size: 992 });
  const [activeActionMenu, setActiveActionMenu] = useState(null);
  const [viewDescriptionData, setViewDescriptionData] = useState(null);
  const theme = useTheme();

  const [expandedOps, setExpandedOps] = useState({});
  const moreButtonRefs = useRef({});

  const iconMap = {
    delete: { light: deleteLight, dark: deleteDark },
    edit: { light: editLight, dark: editDark },
    // share: { light: shareLight, dark: shareDark },
    copy: { light: copy, dark: copyDark },
    deleteIcon: { light: deleteContentLight, dark: deleteContentDark }
  };

  const getIcon = (type) => iconMap[type]?.[theme] || "";
  const currentSessionPinName = useMemo(() => {
    if (typeof window === "undefined") return "";
    return (window.localStorage.getItem("pinName") || "").trim().toLowerCase();
  }, []);
  const shouldHidePinActions = (pinName = "") =>
    activeTab === 0 &&
    Boolean(currentSessionPinName) &&
    String(pinName).trim().toLowerCase() === currentSessionPinName;
  const isCurrentSessionPin = (pinName = "") =>
    Boolean(currentSessionPinName) &&
    String(pinName).trim().toLowerCase() === currentSessionPinName;

  // Delete selected rows (bulk)
  const handleBulkDelete = async () => {
    const idsToDelete = Object.keys(selectedRows).map(Number);
    let deletedCount = 0;
    let failedCount = 0;
    const successfullyDeletedIds = new Set();

    for (const id of idsToDelete) {
      try {
        if (activeTab === 0) {
          const pinId = secretsList[id]?.inputs?.tokenKey || "";
          if (!pinId) {
            failedCount += 1;
            continue;
          }
          try {
            const resp = await callDeletePin(pinId);
            if (resp?.error) {
              failedCount += 1;
              continue;
            }
            deletedCount += 1;
            successfullyDeletedIds.add(id);
          } catch (pinError) {
            console.warn(`Error deleting pin at index ${id}:`, pinError);
            failedCount += 1;
          }
        } else {
          const secretPath = secretsList[id]?.inputs?.secretPath || "";
          await deleteSecret(secretPath);
          deletedCount += 1;
          successfullyDeletedIds.add(id);
        }
      } catch (error) {
        console.warn(`Error deleting item at index ${id}:`, error);
        failedCount += 1;
      }
    }

    const updatedSecretsList = secretsList.filter(
      (_, index) => !successfullyDeletedIds.has(index)
    );
    setSecretsList(updatedSecretsList);
    setSelectedRows({});
    setOpenDeleteModal(false);
    if (failedCount > 0 && deletedCount > 0) {
      showToast(
        `${deletedCount} deleted, ${failedCount} failed. Please try again.`,
        "error"
      );
    } else if (failedCount > 0) {
      showToast(`Failed to delete ${activeTab === 0 ? "pins" : "secrets"}`, "error");
    } else {
      showToast(
        `${activeTab === 0 ? "Pins" : "Secrets"} deleted successfully`,
        "success"
      );
    }
  };

  // Delete single row
  const handleRowDelete = async () => {
    let updatedSecretsList = [...secretsList];
    try {
      if (deleteId === null || deleteId === undefined) {
        showToast("No item selected for deletion", "error");
        return;
      }
      if (activeTab === 0) {
        const pinId = secretsList[deleteId]?.inputs?.tokenKey || "";
        if (!pinId) {
          showToast("Pin ID is missing. Unable to delete this pin.", "error");
          return;
        }
        try {
          const resp = await callDeletePin(pinId);

          if (resp?.error) {
            const errorMessage =
              resp?.message ||
              (typeof resp?.error === "string" ? resp.error : "Failed to delete pin");
            showToast(errorMessage, "error");
          } else {
            showToast("Pin deleted successfully", "success");
            updatedSecretsList = secretsList.filter(
              (_, index) => index !== deleteId
            );
            setSecretsList(updatedSecretsList);
          }
        } catch (pinError) {
          console.warn("Error in handleRowDelete (pin):", pinError);
          showToast(pinError?.message || "Failed to delete pin", "error");
        }
      } else {
        try {
          const secretPath = secretsList[deleteId]?.inputs?.secretPath || "";
          await deleteSecret(secretPath);
          updatedSecretsList = secretsList.filter(
            (_, index) => index !== deleteId
          );
          setSecretsList(updatedSecretsList);
        } catch (secretError) {
          console.warn("Error in handleRowDelete (secret):", secretError);
          showToast(secretError?.message || "An unexpected error occurred", "error");
        }
      }
    } catch (error) {
      console.warn("Error in handleRowDelete:", error);
      showToast(
        activeTab === 0
          ? error?.message || "Failed to delete pin"
          : error?.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setDeleteId(null);
      setOpenDeleteModalRow(false);
    }
  };

  // Transform secretsList for table display
  // const transformedData = useMemo(() => {
  //   return (secretsList || []).map((item, index) => ({
  //     id: index,
  //     name: item.inputs?.secretPath || "",
  //     ttl: item.selects?.selectedTTL || "",
  //     alert: item.selects?.selectedExpireAlert || "",
  //     description: item.inputs?.description || ""
  //   }));
  // }, [secretsList]);

  // Transform secretsList for table display based on activeTab
  const transformedData = useMemo(() => {
    return (secretsList || []).reduce((acc, item, index) => {
      if (activeTab === 0) {
        // For pins (activeTab 0), only include if key is not empty
        const key = item.inputs?.key;
        const expiryTimeValue = item.selects?.selectedTTL || "";

        // Filter out expired pins
        if (expiryTimeValue) {
          const PREFIX = "PIN expires at ";
          let dateStr = expiryTimeValue;
          if (typeof dateStr === "string" && dateStr.startsWith(PREFIX)) {
            dateStr = dateStr.substring(PREFIX.length);
          }
          const parsed = new Date(dateStr);
          if (!isNaN(parsed.getTime()) && parsed.getTime() < Date.now()) {
            return acc; // Skip this item
          }
        }

        // if (key && key.trim() !== "") {
        acc.push({
          id: index,
          allowed_pin_ops: item.inputs?.operations_allowed || [],
          expiryTime: expiryTimeValue,
          description: item.inputs?.description || "",
          name: key && key.trim() !== "" ? key : "N/A",
          client: item.inputs?.url || "",
        });
        // }
      } else {
        // For other tabs (activeTab 1-3)
        acc.push({
          id: index,
          name: item.inputs?.secretPath || "",
          ttl: item.selects?.selectedTTL || "",
          alert: item.selects?.selectedExpireAlert || "",
          description: item.inputs?.description || ""
        });
      }
      return acc;
    }, []);
  }, [secretsList, activeTab]);


  // Filter by search
  const filteredData = useMemo(() => {
    return transformedData.filter((item) =>
      item.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }, [transformedData, searchQuery]);

  const isAllChecked =
    filteredData.length > 0 &&
    Object.keys(selectedRows).length === filteredData.length;

  // Select all toggle
  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      const newSelected = {};
      filteredData.forEach((item) => {
        newSelected[item.id] = true;
      });
      setSelectedRows(newSelected);
    } else {
      setSelectedRows({});
    }
  };

  // Toggle single row selection
  const toggleRow = (id) => {
    setSelectedRows((prev) => {
      const updated = { ...prev };
      if (updated[id]) {
        delete updated[id];
      } else {
        updated[id] = true;
      }
      return updated;
    });
  };

  // Edit save handler: updates the full secretsList at editingIndex
  const handleEditSave = async () => {
    const updatedSecret = formData;
    setSecretsList((prevList) =>
      prevList.map((item, idx) => (idx === editingIndex ? updatedSecret : item))
    );

    await handleSaveAddSecret();
    setOpenEditModal(false);
    setEditingIndex(null);
    setFormErrors({});
  };

  // Table columns
  const columns = useMemo(
    () => {
      const selectionColumn = {
        id: "selection",
        Header: () => (
          <SquareCheckBox
            label=""
            isChecked={isAllChecked}
            isDisable={false}
            onChange={(e) => {
              e.stopPropagation();
              handleSelectAll(e.target.checked);
            }}
          />
        ),
        Cell: ({ row }) => (
          <SquareCheckBox
            label=""
            isChecked={!!selectedRows[row.original.id]}
            isDisable={false}
            onChange={(e) => {
              e.stopPropagation();
              toggleRow(row.original.id);
            }}
          />
        ),
        width: "3%"
      };
      const commonColumns = [
      ];

      // Description column (common but with different widths)
      const descriptionColumn = {
        Header: "Description",
        accessor: "description",
        width: activeTab === 0 ? "40%" : "35%",
        Cell: ({ value }) => <div>{value ? value : "No Description"}</div>
      };



      // Action column is unchanged
      const actionsColumn = {
        Header: "",
        id: "actions",
        width: "15%",
        Cell: ({ row }) => {
          const hideActions = shouldHidePinActions(row.values.name);
          if (hideActions) {
            return <div className="actions"></div>;
          }
          return (
            <div className="actions">
              <img
                src={getIcon("delete")}
                alt="Delete"
                className="actionIcon"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDeleteModalRow(true);
                  setDeleteId(row.original.id);
                }}
              />
              {row.values.name !== "N/A" && (

                <img
                  src={getIcon("edit")}
                  alt="Edit"
                  className="actionIcon"
                  onClick={(e) => {
                    e.stopPropagation();
                    setFormErrors({});

                    // Prepare full secret data for editing
                    const secretData = secretsList[row.original.id];
                    // console.log("after clicking edit ,the secret data is and row is ", secretData, row);
                    setSelectedData(secretData);
                    setEditingIndex(row.original.id);

                    // NEW CODE: Handle operations differently based on activeTab
                    let operations;
                    if (activeTab === 0) {
                      // For pins, use operations_allowed
                      operations = secretData.inputs?.operations_allowed || [];
                    } else {
                      // For other secrets, use existing selectedOperations
                      operations = secretData.selects?.selectedOperations;
                    }

                    setFormData({
                      addNewData: false,
                      inputs: {
                        secretPath: secretData.inputs?.secretPath || "",
                        password: secretData.inputs?.password || "",
                        description: secretData.inputs?.description || "",
                        file: secretData.inputs?.file || null,
                        minSize:
                          secretData.inputs?.minSize || 0,
                        maxSize:
                          secretData.inputs?.maxSize || 0,
                        pin: secretData.inputs?.pin || "",
                        tokenKey: secretData.inputs?.tokenKey || "",
                        key: secretData.inputs?.key || "",
                        generateToken: secretData.inputs?.generateToken || "",
                        checkboxes: {
                          autoRotate:
                            secretData.inputs?.checkboxes?.autoRotate || false,
                          encryptAtRest:
                            secretData.inputs?.checkboxes?.encryptAtRest || false,
                          restrictAttestedCode:
                            secretData.inputs?.checkboxes?.restrictAttestedCode ||
                            false
                        },
                        url: secretData.inputs.url || "",
                        username: secretData.inputs.username || "",
                        totp: secretData.inputs.totp || "",
                        keyValuePairs: secretData.inputs?.keyValuePairs || [{ key: "", value: "" }]
                      },
                      selects: {
                        selectedSecretType:
                          secretData.selects?.selectedSecretType || "",
                        selectedSecretValueTTL:
                          secretData.selects?.selectedSecretValueTTL || "",
                        selectedTTL: secretData.selects?.selectedTTL || "",
                        selectedExpireAlert:
                          secretData.selects?.selectedExpireAlert || "",
                        autoRotateTTL: secretData.selects?.autoRotateTTL || "",
                        keyInputMethod: secretData.selects?.keyInputMethod || "",
                        // selectedOperations: secretData.selects?.selectedOperations,
                        selectedOperations: operations,
                      }
                    });

                    setOpenEditModal(true);
                  }}
                />
              )}
              {
                (activeTab === 3 || activeTab === 2 || activeTab === 1) && <img
                  src={getIcon("copy")}
                  alt="Copy"
                  className="actionIcon"
                  onClick={(e) => {
                    e.stopPropagation();
                    const secretData = secretsList[row.original.id];
                    // setOpenShareModal(true);
                    if (activeTab === 1) {
                      navigator.clipboard.writeText(secretData?.inputs?.tokenKey);
                    }
                    else {
                      navigator.clipboard.writeText(secretData?.inputs?.key);
                    }
                  }}
                />
              }

            </div>
          );
        }
      };
      if (activeTab === 0) {
        // For pins
        return [
          // ...commonColumns,
          {
            Header: "Ops",
            accessor: "allowed_pin_ops",
            width: "27%",
            Cell: ({ value }) => {
              const [expanded, setExpanded] = useState(false);
              const containerRef = useRef(null);

              // Handle empty or non-array values
              if (!value || !Array.isArray(value) || value.length === 0) {
                return <div className="no-ops">No operations</div>;
              }

              // Number of items to show in collapsed view
              const VISIBLE_ITEMS = 3;
              const totalItems = value.length;
              const hasMoreItems = totalItems > VISIBLE_ITEMS;

              // For accessibility - stop propagation but allow keyboard navigation
              const handleKeyDown = (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setExpanded(!expanded);
                }
              };

              return (
                <div
                  className={`ops-expandable-container ${expanded ? 'expanded' : ''}`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent row selection
                    setExpanded(!expanded);
                  }}
                  ref={containerRef}
                  tabIndex={0} // Make it focusable
                  onKeyDown={handleKeyDown}
                  role="button"
                  aria-expanded={expanded}
                >
                  <div className="ops-content">
                    {/* Always render all items - the container's overflow will handle visibility */}
                    {value.map((op, i) => (
                      <div key={i} className="ops-item">{op}</div>
                    ))}
                  </div>

                  {hasMoreItems && (
                    <div className="ops-expander">
                      <span className="expand-indicator">
                        {expanded ? '▲ Show less' : `▼ +${totalItems - VISIBLE_ITEMS} more`}
                      </span>
                    </div>
                  )}
                </div>
              );
            }
          },

          // {
          //   Header: "Ops",
          //   accessor: "allowed_pin_ops",
          //   width: "27%",
          //   Cell: ({ value, row }) => {
          //     // Handle empty or non-array values
          //     if (!value || !Array.isArray(value) || value.length === 0) {
          //       return <div className="no-ops">No operations</div>;
          //     }

          //     // Convert value to array of strings if it's not already
          //     const operationsArray = Array.isArray(value) ? value : [String(value)];

          //     const MAX_VISIBLE = 3;
          //     const hasMore = operationsArray.length > MAX_VISIBLE;
          //     const rowId = row.original.id;
          //     const isExpanded = expandedOps[rowId];

          //     return (
          //       <div className="ops-container" onClick={(e) => e.stopPropagation()}>
          //         {/* First few operations */}
          //         {operationsArray.slice(0, MAX_VISIBLE).map((op, i) => (
          //           <span key={i} className="ops-pill">{op}</span>
          //         ))}

          //         {/* More button */}
          //         {hasMore && (
          //           <button
          //             className="ops-more-button"
          //             onClick={(e) => {
          //               e.stopPropagation();
          //               setExpandedOps({
          //                 ...expandedOps,
          //                 [rowId]: !expandedOps[rowId]
          //               });
          //             }}
          //           >
          //             +{operationsArray.length - MAX_VISIBLE} More
          //           </button>
          //         )}

          //         {/* Expanded view */}
          //         {hasMore && isExpanded && (
          //           <div className="ops-expanded-view"

          //           >
          //             <div className="expanded-header">
          //               All Operations
          //               <button
          //                 className="close-expanded"
          //                 onClick={(e) => {
          //                   e.stopPropagation();
          //                   setExpandedOps({
          //                     ...expandedOps,
          //                     [rowId]: false
          //                   });
          //                 }}
          //               >
          //                 ×
          //               </button>
          //             </div>
          //             <div className="expanded-content">
          //               {operationsArray.map((op, i) => (
          //                 <span key={i} className="ops-pill">{op}</span>
          //               ))}
          //             </div>
          //           </div>
          //         )}
          //       </div>
          //     );
          //   }
          // },
          {
            Header: "Client",
            accessor: "client",
            width: "20%",
          },
          {
            Header: "Expiry Time",
            accessor: "expiryTime",
            width: "20%",
            Cell: ({ value }) => {
              if (!value) return <div>-</div>;
              const PREFIX = "PIN expires at ";
              let dateStr = value;
              if (typeof value === "string" && value.startsWith(PREFIX)) {
                dateStr = value.substring(PREFIX.length);
              }
              const parsed = new Date(dateStr);
              if (!isNaN(parsed.getTime())) {
                if (parsed.getTime() < Date.now()) {
                  return <div className="expired">Expired</div>;
                }
                return <div>{value}</div>;
              }
              return <div>{value}</div>;
            }
          },
          {
            Header: "Name",
            accessor: "name",
            width: "20%",
            Cell: ({ value }) => (
              <div>
                {value}
                {isCurrentSessionPin(value) && (
                  <span style={{ marginLeft: "8px", color: "var(--text-brand, #7b2cbf)", fontWeight: 600 }}>
                    (Current session PIN)
                  </span>
                )}
              </div>
            )
          },
          descriptionColumn,
          actionsColumn
        ];
      } else {
        // For other tabs (secrets, tokens, etc.)
        return [
          selectionColumn,
          {
            Header: "Secret Path",
            accessor: "name",
            width: "29%"
          },
          {
            Header: "Time To Live",
            accessor: "ttl",
            width: "20%"
          },
          {
            Header: "Expire Alert before",
            accessor: "alert",
            width: "31%"
          },
          descriptionColumn,
          actionsColumn
        ];
      }





    },
    [selectedRows, isAllChecked, theme, secretsList, activeTab, expandedOps]
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: filteredData
    });




  return (
    <div className="secretTableHeader">
      {hasTabData.length >= 0 ? (
        <div style={{ height: "100%" }}>
          <div className="tabsTableWrapper">
            {isMobile && secretsList.length > 0 && (
              <div className="selectAllMobile">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <SquareCheckBox
                    label=""
                    isChecked={isAllChecked}
                    isDisable={false}
                    onChange={(e) => {
                      e.stopPropagation();
                      handleSelectAll(e.target.checked);
                    }}
                  />
                  <p>Select All</p>
                </div>
                <div className="mobileActionButtons" style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  {Object.keys(selectedRows).length > 0 && (
                    <div
                      className="bulkDeleteMobile"
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenDeleteModal(true);
                      }}
                      style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                    >
                      <img
                        src={getIcon("deleteIcon")}
                        alt="Delete"
                        style={{ width: '26px', height: '26px' }}
                      />
                    </div>
                  )}
                  {activeTab === 0 && (
                    <div
                      className="closePinsMobile"
                      onClick={() => {
                        if (setActiveCard) {
                          setActiveCard(0);
                          sessionStorage.setItem("activeCard", "0");
                        }
                      }}
                      style={{
                        cursor: 'pointer',
                        fontSize: '26px',
                        fontWeight: '300',
                        lineHeight: '1',
                        color: '#A36BD0',
                        padding: '4px',
                        display: 'flex',
                        alignItems: 'center'
                      }}
                      title="Close Pins and go to Files"
                    >
                      &times;
                    </div>
                  )}
                </div>
              </div>
            )}

            <div className="tableContainer">
              <div className="tableDataContainer">
                {!isMobile ? (
                  <>
                    {filteredData.length === 0 ? (
                      <div className="noDataWrapper">
                        <img
                          src={noData}
                          alt="No Data Found"
                          className="noDataImage"
                        />
                        <p className="noDataText">No secrets found</p>
                      </div>
                    ) : (
                      <table className="table" {...getTableProps()}>
                        <thead className="tableHead">
                          {headerGroups.map((headerGroup) => {
                            const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();

                            return (
                              <tr key={key} className="tableHeadRow" {...headerGroupProps}>
                                {headerGroup.headers.map((column) => {
                                  const { key: colKey, ...colProps } = column.getHeaderProps();

                                  return (
                                    <th
                                      key={colKey}
                                      className="tableHeadRowHeaderBox"
                                      style={{ width: column.width }}
                                      {...colProps}
                                    >
                                      {column.render("Header")}
                                    </th>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </thead>

                        <tbody className="tableBody" {...getTableBodyProps()}>
                          {rows.map((row) => {
                            prepareRow(row);
                            const { key, ...rowProps } = row.getRowProps();

                            return (
                              <tr
                                key={key}
                                className="tableBodyRow"
                                {...rowProps}
                                onClick={() => toggleRow(row.original.id)}
                              >
                                {row.cells.map((cell) => {
                                  const { key: cellKey, ...cellProps } = cell.getCellProps();

                                  return (
                                    <td
                                      key={cellKey}
                                      className="tableBodyRowData2"
                                      style={{ width: cell.column.width }}
                                      {...cellProps}
                                    >
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            );
                          })}
                        </tbody>

                      </table>
                    )}
                  </>
                ) : (
                  <div className="tableDataContainer">
                    {filteredData.length === 0 ? (
                      <div className="noDataWrapper">
                        <img
                          src={noData}
                          alt="No Data Found"
                          className="noDataImage"
                        />
                        <p className="noDataText">No secrets found</p>
                      </div>
                    ) : (
                      filteredData.map((item) => {
                        if (activeTab === 0) {
                          return (
                            <div key={item.id} className="pin-card">
                              <div className="pin-card-header">
                                <div className="operation-icon-title">
                                  <img
                                    src={theme === "light" ? induzLogo : induzLogoDark}
                                    alt="Induz"
                                    className="pin-card-logo"
                                  />
                                  <span className="operation-title">
                                    {item.allowed_pin_ops?.includes("All Operations") || !item.allowed_pin_ops || item.allowed_pin_ops.length === 0
                                      ? "All Operations"
                                      : "Custom Operations"}
                                  </span>
                                </div>
                                {!shouldHidePinActions(item.name) && (
                                  <div className="pin-card-actions">
                                    <div
                                      className="kebab-menu-trigger"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setActiveActionMenu(activeActionMenu === item.id ? null : item.id);
                                      }}
                                    >
                                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="1" />
                                        <circle cx="12" cy="5" r="1" />
                                        <circle cx="12" cy="19" r="1" />
                                      </svg>
                                    </div>

                                    {activeActionMenu === item.id && (
                                      <div className="mobile-action-dropdown">
                                        <div
                                          className="mobile-action-item"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setActiveActionMenu(null);
                                            setViewDescriptionData(item.description || "No description provided");
                                          }}
                                        >
                                          <span>📄</span> Description
                                        </div>
                                        <div
                                          className="mobile-action-item delete-action"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            setActiveActionMenu(null);
                                            setDeleteId(item.id);
                                            setOpenDeleteModalRow(true);
                                          }}
                                        >
                                          <img src={getIcon("delete")} alt="delete" /> Delete
                                        </div>
                                      </div>
                                    )}
                                    {activeActionMenu === item.id && (
                                      <div className="mobile-action-backdrop" onClick={(e) => { e.stopPropagation(); setActiveActionMenu(null); }} />
                                    )}
                                  </div>
                                )}
                              </div>

                              <div className="pin-card-body">
                                <div className="pin-card-row">
                                  <span className="pin-label">Client</span>
                                  <span className="pin-colon">:</span>
                                  <span className="pin-value">{item.client || "N/A"}</span>
                                </div>
                                <div className="pin-card-row">
                                  <span className="pin-label">Expiry</span>
                                  <span className="pin-colon">:</span>
                                  <span className="pin-value">
                                    {(() => {
                                      if (!item.expiryTime) return "-";
                                      const PREFIX = "PIN expires at ";
                                      let dateStr = item.expiryTime;
                                      if (typeof item.expiryTime === "string" && item.expiryTime.startsWith(PREFIX)) {
                                        dateStr = item.expiryTime.substring(PREFIX.length);
                                      }
                                      return dateStr;
                                    })()}
                                  </span>
                                </div>
                                <div className="pin-card-row">
                                  <span className="pin-label">Name</span>
                                  <span className="pin-colon">:</span>
                                  <span className="pin-value">
                                    {item.name || "N/A"}
                                    {isCurrentSessionPin(item.name) && (
                                      <span style={{ marginLeft: "8px", color: "var(--text-brand, #7b2cbf)", fontWeight: 600 }}>
                                        (Current session PIN)
                                      </span>
                                    )}
                                  </span>
                                </div>
                                <div className="pin-card-row">
                                  <span className="pin-label">Status</span>
                                  <span className="pin-colon">:</span>
                                  <span className="pin-value">
                                    {(() => {
                                      let isExpired = false;
                                      if (item.expiryTime) {
                                        const PREFIX = "PIN expires at ";
                                        let dateStr = item.expiryTime;
                                        if (typeof item.expiryTime === "string" && item.expiryTime.startsWith(PREFIX)) {
                                          dateStr = item.expiryTime.substring(PREFIX.length);
                                        }
                                        try {
                                          const date = new Date(dateStr);
                                          if (!isNaN(date.getTime()) && date.getTime() < Date.now()) {
                                            isExpired = true;
                                          }
                                        } catch (e) { }
                                      }
                                      return (
                                        <span className={`status-pill ${isExpired ? "expired" : "active"}`}>
                                          {isExpired ? "Expired" : "Active"}
                                        </span>
                                      );
                                    })()}
                                  </span>
                                </div>
                                <div className="pin-card-row">
                                  <span className="pin-label">Created</span>
                                  <span className="pin-colon">:</span>
                                  <span className="pin-value">
                                    {item.description ? item.description.replace('PIN created at ', '') : "N/A"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          );
                        }
                        return (
                          <div key={item.id} className="mobileSecretCard">
                            <div className="mobileSecretCardItem">
                              <SquareCheckBox
                                label=""
                                isChecked={!!selectedRows[item.id]}
                                onChange={() => toggleRow(item.id)}
                              />
                              <div className="mobileSecretCardActions">
                                {item.name !== "N/A" && (
                                  <img
                                    src={getIcon("edit")}
                                    alt="Edit"
                                    className="actionIcon"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setFormErrors({});

                                      const secretData = secretsList[item.id];
                                      setSelectedData(secretData);
                                      setEditingIndex(item.id);

                                      setFormData({
                                        addNewData: false,
                                        inputs: {
                                          secretPath:
                                            secretData.inputs?.secretPath || "",
                                          password:
                                            secretData.inputs?.password || "",
                                          description:
                                            secretData.inputs?.description || "",
                                          file: secretData.inputs?.file || null,
                                          url: "",
                                          username: "",
                                          totp: "",
                                          pin: secretData.inputs?.pin || "",
                                          tokenKey: secretData.inputs?.tokenKey || "",
                                          key: secretData.inputs?.key || "",
                                          generateToken: secretData.inputs?.generateToken || "",
                                          minSize:
                                            secretData.inputs?.minSize || 0,
                                          maxSize:
                                            secretData.inputs?.maxSize || 0,
                                          checkboxes: {
                                            autoRotate:
                                              secretData.inputs?.checkboxes
                                                ?.autoRotate || false,
                                            encryptAtRest:
                                              secretData.inputs?.checkboxes
                                                ?.encryptAtRest || false,
                                            restrictAttestedCode:
                                              secretData.inputs?.checkboxes
                                                ?.restrictAttestedCode || false
                                          },
                                          keyValuePairs: [{ key: "", value: "" }]
                                        },
                                        selects: {
                                          selectedSecretType:
                                            secretData.selects
                                              ?.selectedSecretType || "",
                                          selectedSecretValueTTL:
                                            secretData.selects
                                              ?.selectedSecretValueTTL || "",
                                          selectedTTL:
                                            secretData.selects?.selectedTTL || "",
                                          selectedExpireAlert:
                                            secretData.selects
                                              ?.selectedExpireAlert || "",
                                          autoRotateTTL:
                                            secretData.selects?.autoRotateTTL || "",
                                          keyInputMethod: secretData.selects?.keyInputMethod || "",
                                          selectedOperations: secretData.selects?.selectedOperations,
                                        }
                                      });

                                      setOpenEditModal(true);
                                    }}
                                  />
                                )}
                                <img
                                  src={getIcon("delete")}
                                  alt="Delete"
                                  className="actionIcon"
                                  onClick={() => {
                                    setOpenDeleteModalRow(true);
                                    setDeleteId(item.id);
                                  }}
                                />
                                <img
                                  src={getIcon("share")}
                                  alt="Share"
                                  className="actionIcon"
                                  onClick={() => setOpenShareModal(true)}
                                />
                              </div>
                            </div>
                            <div className="mobileContent">
                              {activeTab === 0 ? (
                                <>
                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Ops</p>
                                    <span>{item.allowed_pin_ops}</span>
                                  </div>

                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Time To Live</p>
                                    <span>{item.ttl}</span>
                                  </div>

                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Description</p>
                                    <span>{item.description}</span>
                                  </div>
                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Name</p>
                                    <span>{item.name}</span>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Secret Path</p>
                                    <span>{item.name}</span>
                                  </div>

                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Time To Live</p>
                                    <span>{item.ttl}</span>
                                  </div>

                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Expire Alert before</p>
                                    <span>{item.alert}</span>
                                  </div>

                                  <div className="mobileSecretCardItems">
                                    <p className="strong">Description</p>
                                    <span>{item.description}</span>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="addSecretBottom">

          </div>
        </div>
      ) : (
        <EmptySecret
          handleCreateSecret={handleCreateSecretModal}
          selectedTab={selectedTab}
        />
      )
      }

      {
        openDeleteModal && (
          <DeleteModal
            isVisible={openDeleteModal}
            handleCancel={() => setOpenDeleteModal(false)}
            handleSave={handleBulkDelete}
            content={`Are you sure you want to delete the selected ${activeTab === 0 ? "Ysafe PINS" : selectedTab + "s"}?`}
          />
        )
      }

      {
        openDeleteModalRow && (
          <DeleteModal
            isVisible={openDeleteModalRow}
            handleCancel={() => setOpenDeleteModalRow(false)}
            handleSave={handleRowDelete}
            content={`Are you sure you want to delete this ${activeTab === 0 ? "Ysafe PIN" : selectedTab}?`}
          />
        )
      }

      {/* Share Modal */}
      {
        openShareModal && !isMobile ? (
          <Modal
            isVisible={openShareModal}
            handleCancel={() => setOpenShareModal(false)}
            heading={selectedTab ? `Share ${selectedTab}` : "Share Secret"}
            showFooter={true}
            submitBtnText="Share"
            handleSave={() => {
              // Implement share logic here
              setOpenShareModal(false);
            }}
          >
            <SecretShare />
          </Modal>
        ) : (
          ""
        )
      }

      {
        openShareModal && isMobile ? (
          <Drawer
            isVisible={openShareModal}
            handleCancel={() => setOpenShareModal(false)}
            heading={selectedTab ? `Share ${selectedTab}` : "Share Secret"}
            showFooter={true}
            submitBtnText="Share"
            handleSave={() => {
              // Implement share logic here
              setOpenShareModal(false);
            }}
          >
            <SecretShare />
          </Drawer>
        ) : (
          ""
        )
      }

      {/* Edit Modal / Drawer */}
      {
        openEditModal &&
        (isMobile ? (
          <Drawer
            rightButtonWith="100%"
            cancelButton={false}
            isVisible={openEditModal}
            handleSave={handleEditSave}
            heading={selectedTab ? `Edit ${selectedTab}` : "Edit Secret"}
            handleCancel={() => setOpenEditModal(false)}
            showHeader={true}
            mockClass="addSecret"
            submitBtnText="Save"
            showFooter={true}
          >
            <AddSecret
              updateOperation={true}
              activeTab={activeTab}
              setFormData={setFormData}
              formData={formData}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
            />
          </Drawer>
        ) : (
          <Modal
            isVisible={openEditModal}
            handleCancel={() => setOpenEditModal(false)}
            heading={selectedTab ? `Edit ${selectedTab}` : "Edit Secret"}
            showFooter={true}
            submitBtnText="Save"
            handleSave={handleEditSave}
          >
            <AddSecret
              updateOperation={true}
              activeTab={activeTab}
              setFormData={setFormData}
              formData={formData}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
            />
          </Modal>
        ))
      }
      {/* Description Modal for Mobile */}
      {
        isMobile && viewDescriptionData !== null && (
          <div className="description-modal-overlay" onClick={() => setViewDescriptionData(null)} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", zIndex: 2000, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
            <div className="description-modal-content" onClick={e => e.stopPropagation()} style={{ background: theme === "light" ? "#fff" : "var(--background-bg-dark)", width: "100%", maxHeight: "60vh", borderTopLeftRadius: "16px", borderTopRightRadius: "16px", padding: "20px", overflowY: "auto" }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px", alignItems: "center" }}>
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "600", color: "var(--text-grey-strong)" }}>Description</h3>
                <button onClick={() => setViewDescriptionData(null)} style={{ background: "none", border: "none", fontSize: "24px", color: "var(--text-grey-strong)" }}>&times;</button>
              </div>
              <div style={{ fontSize: "14px", lineHeight: "1.5", color: "var(--text-grey-strong)", whiteSpace: "pre-wrap" }}>{viewDescriptionData}</div>
            </div>
          </div>
        )
      }
    </div >
  );
};

export default SecretsTable;
